import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import Footer from '@/components/Footer';
import * as TextBlocks from '@/utilities/TextBlocks';
import { MarkdownBlock } from '@/utilities/TextBlocks';
import { StyleSheet, View } from "react-native";
import { CustomText } from "@/components/CustomText";
import { MapView } from "@/components/MapView";
import { ArrowIcon, Button, Button as Button95, Checkbox, Hourglass, NumberInput, Panel, TextInput } from 'react95-native-rabbl';
import { Gender } from '@/types/user_info';
import { Image } from 'expo-image';
import { Link, useLocalSearchParams } from 'expo-router';
import * as AppUtilities from "@/utilities/AppUtilities";
import * as AppUtils from '@/utilities/AppUtils';
import * as AppConstants from "@/utilities/AppConstants";
import * as AppConsts from "@/utilities/AppConsts";
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { updateMen, updateWomen } from '@/state/mapfilters';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  map: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    width: "100%",
  },
  header: {
    height: 40,
    width: "100%",
    gap: 5,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 10,
  },
  filterImage: {
    width: 32,
    height: 32,
  },
});

export default function Map() {
  const men = useSelector((state: RootState) => state.mapFilters.men);
  const women = useSelector((state: RootState) => state.mapFilters.women);
  const filterAgeMin = useSelector((state: RootState) => state.mapFilters.ageMin);
  const filterAgeMax = useSelector((state: RootState) => state.mapFilters.ageMax);
  const filterHeightMin = useSelector((state: RootState) => state.mapFilters.heightMin);
  const filterHeightMax = useSelector((state: RootState) => state.mapFilters.heightMax);
  const dispatch = useDispatch();

  let desiredGenders = 0;
  if (men) {
    desiredGenders |= Gender.GENDER_MAN;
  }
  if (women) {
    desiredGenders |= Gender.GENDER_WOMAN;
  }
  
  return (
    <View style={styles.map}>
      <Meta title={"Map"} />
      {
        AppUtilities.isWeb() && (
          <View style={styles.header}>
            <View>
              <Checkbox
                status={men ? 'checked' : 'unchecked'}
                onPress={() => dispatch(updateMen(men ? false : true))}
                label={"Men"}
              />
            </View>
            <View>
              <Checkbox
                status={women ? 'checked' : 'unchecked'}
                onPress={() => dispatch(updateWomen(women ? false : true))}
                label={"Women"}
              />
            </View>
            <Link href="/mapfilter" asChild={AppUtilities.isWeb()}>
              <Image
                style={styles.filterImage}
                source={require('@/assets/images/gears32x32.png')}
              />
            </Link>
          </View>
        )
      }
      <View style={styles.map}>
        <MapView
          desiredGenders={desiredGenders}
          ageMin={filterAgeMin}
          ageMax={filterAgeMax}
          heightMin={filterHeightMin}
          heightMax={filterHeightMax}
        />
      </View>
    </View>
  );
}
